import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  SkipSelf,
  ViewChild,
} from '@angular/core';
import {
  ControlContainer,
  FormGroupDirective,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms';
import { PrFormSelectListComponent } from '@app/components/pr-form/pr-form-select-list/pr-form-select-list.component';
import { PrSubformComponent } from '@app/components/pr-form/pr-subform/pr-subform.component';
import { PrTableFormComponent } from '@app/components/pr-form/pr-table-form/pr-table-form.component';
import { PrTableColumn } from '@app/components/pr-table/pr-table.component';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { API_ROUTE_SUPPORTS_SEARCH } from '@app/forms/subscription/api/api-router';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as _ from 'lodash';
import { Observable, Subject, combineLatest, debounceTime, map, mergeMap, takeUntil, tap } from 'rxjs';

@UntilDestroy()
@Component({
    selector: 'support',
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class SupportComponent implements OnInit, AfterViewInit {
  @Input() avDistribution = 'FREE';
  @Input() derrors;
  supports: any[] = [];
  supportTypes;
  supportsLength = 0;
  supportsPageSize = 15;
  currentPage = 0;
  _ = _;
  doneSubject: Subject<void> = new Subject<void>();

  callback: any;
  entity: any = {};
  productId: any;
  // criteriaForm: FormGroup;

  @ViewChild('tableForm', { static: true }) tableForm: PrTableFormComponent;
  @ViewChild('supportsForm', { static: true }) supportsForm: PrSubformComponent;
  @ViewChild('formSelectList', {
    static: true,
    read: PrFormSelectListComponent,
  })
  formSelectList: PrFormSelectListComponent;

  columnsDefinition = [
    new PrTableColumn('Noms des supports', 'name', { span: 3 }),
    new PrTableColumn('Repartition', 'initalRepartition', 'input', {
      changeCallback: this.tableAllocationColumnValueChanged.bind(this),
      suffix: '%',
      span: 2,
    }),
    new PrTableColumn('Montant investi', 'investedAmount', 'currency', {
      span: 2,
    }),
    new PrTableColumn('', 'action', 'action'),
  ];
  criteriaForm: UntypedFormGroup;
  supports2: any[] = [];
  criteriasLoading: boolean = true;
  private destroy$ = new Subject<void>();
  _defaultAllocationFormValue: any;
  constructor(
    private controlContainer: FormGroupDirective,
    private httpApi: HttpApiService,
    private referenceDao: ReferenceDao,
    protected formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    this.criteriaForm = this.formBuilder.group({
      autocomplete: [],
      supportTypes: [],
      enableViewAll: [false],
    });
  }
  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  get form() {
    return this.controlContainer.form.get('parameters') as UntypedFormGroup;
  }

  ngOnInit(): void {
    const pledge = this.subscriptionFacade.getPledge();

    this.productId = pledge?.products?.[0]?.productId;
    this.formSelectList.loading = true;

    this.supportTypes = combineLatest([
      this.referenceDao.getSupportTypes(),
      this.search(),
    ]).pipe(
      map(([supportTypes, search]) => supportTypes),

      tap(data => {}),
    );

    if (pledge?.products?.[0]?.parameters?.avDistribution === 'PILOTED') {
      this.criteriaForm.get('supportTypes').setValue('MANDAT_GESTION');
    }

    this.criteriaForm.valueChanges
      .pipe(
        untilDestroyed(this),
        tap(() => (this.formSelectList.loading = true)),
        debounceTime(500),
        mergeMap(this.search.bind(this)),
      )
      .subscribe();
  }
  createModel(item) {
    const model = {
      id: [item?.id || null],
      isin: [item?.isin || item?.supportIsin || null],
      index: [item?.index || null],
      omniprodId: [item?.omniProductId || item?.omniprodId || null],
      name: [item?.name || null],
      initalRepartition: [item?.initalRepartition || null],
      monthlyRepartition: [item?.monthlyRepartition || null],

      favorite: [item?.favorite || null],
      type: [item?.type || null],
      supportDescription: [null],
      totalInvestedAmount: [null],
      riskScore: [item?.details?.profilRisk?.value || null],
    };
    return model;
  }

  changeSupportsPage(event) {
    this.currentPage = event.pageIndex;
    this.formSelectList.loading = true;
    this.search().subscribe();
  }

  search(): Observable<any> {
    const searchOptions = this.buildSearchOptions();

    return this.searchSupports(searchOptions).pipe(
      takeUntil(this.destroy$),
      map(res => {
        this.formSelectList.loading = false;
        this.supportsLength = res.totalElements;
        this.supports = res.content;
        return res;
      }),
      tap(() => {
        this.searchAndFillFullData().subscribe();
        this.cdr.detectChanges();
      }),
    );
  }
  searchAndFillFullData(): Observable<any> {
    const searchOptions = this.buildSearchOptions();
    searchOptions.fillFullData = true;

    return this.searchSupports(searchOptions).pipe(
      takeUntil(this.destroy$),
      map(res => {
        this.formSelectList.loading = false;
        this.criteriasLoading = false;
        this.supportsLength = res.totalElements;
        this.supports2 = res.content;
        this.supports = res.content;
        return res;
      }),
      tap(() => this.cdr.detectChanges()),
    );
  }

  private buildSearchOptions(): any {
    return {
      page: this.currentPage + 1,
      size: this.supportsPageSize,
      autocomplete: this.criteriaForm.value.autocomplete,
      supportTypes: this.criteriaForm.value.supportTypes
        ? [this.criteriaForm.value.supportTypes]
        : undefined,
      lifeInsuranceId: this.productId,
      noStrike: !this.criteriaForm.value.enableViewAll,
      amendmentMapped: true,
      isAvailableInSimulationAndSubscription: true,
    };
  }

  private searchSupports(searchOptions: any): Observable<any> {
    return this.httpApi
      .post(API_ROUTE_SUPPORTS_SEARCH, {
        ...searchOptions,
        active: true,
      })
      .pipe(takeUntil(this.destroy$));
  }

  onSupportSelect(support) {
    let newControl = this.formBuilder.group(this.createModel(support));
    let formArray = this.form.controls.supportRepartition as UntypedFormArray;
    newControl.setValue({ ...newControl.value, index: formArray.value.length });
    formArray.push(newControl);
    // set parent form as dirty
    this.form.markAsDirty();
  }

  onSupportDeselect(support) {
    let formArray = this.form.controls.supportRepartition as UntypedFormArray;
    let control = formArray.controls.findIndex(
      c => c.value.id == support.id || c.value.isin == support.isin,
    );
    formArray.removeAt(control);
    this.form.markAsDirty();
  }

  tableAllocationColumnValueChanged(value: any, row: any, column: any) {
    this.supportRepartition.controls[row.index].setValue({
      ...this.supportRepartition.controls[row.index].value,
      [column.name]: value / 100,
    });
    this.markAsDirtyTouchedAndRefresh(row.index);
  }

  cancelManageAllocationform() {
    this.entity = this._defaultAllocationFormValue.supportRepartition;
    this._defaultAllocationFormValue = [];
  }

  validManageAllocationform() {
    this.tableForm.initTable();
    this._defaultAllocationFormValue = [];
  }

  markAsDirtyTouchedAndRefresh(control) {
    this.supportRepartition.controls[control].markAsDirty();
    this.supportRepartition.controls[control].markAsTouched();
    this.tableForm.initTable();
  }

  formatTableDataFunction() {
    return data =>
      _(data)
        .map((data, i) => {
          return {
            index: i,
            name: data.name,
            initalRepartition: data.initalRepartition * 100,
            investedAmount: data.totalInvestedAmount * data.initalRepartition,
            totalInvestedAmount: data.totalInvestedAmount,
          };
        })
        .value();
  }

  newOptionLogic() {
    //First element at 100%
    if (+this.supportRepartition.controls.length == 1)
      return this.supportRepartition.controls[0].setValue({
        ...this.supportRepartition.controls[0].value,
        initalRepartition: 1,
        shareCount: this.supportRepartition.controls[0].value.partPrice
          ? Math.round(
              this.supportRepartition.controls[0].value.totalInvestedAmount /
                this.supportRepartition.controls[0].value.partPrice,
            )
          : '',
      });

    // Form untouched = even allocation
    if (!this.supportRepartition.dirty) {
      this.supportRepartition.controls[0].setValue({
        ...this.supportRepartition.controls[0].value,
        initalRepartition: 0,
      });

      //Ignore first control in order to set the missing allocation percent inside
      _.forEach(this.supportRepartition.controls, (c, i) =>
        +i != 0
          ? c.setValue({
              ...c.value,
              initalRepartition: this.floored(
                1 / +this.supportRepartition.controls.length,
              ),
              shareCount: c.value.partPrice
                ? Math.round(
                    (this.floored(
                      1 / +this.supportRepartition.controls.length,
                    ) *
                      c.value.totalInvestedAmount) /
                      c.value.partPrice,
                  )
                : '',
            })
          : null,
      );

      let allocationLeft =
        this.totalAllocatedPercent < 1
          ? this.floored(1 - this.totalAllocatedPercent)
          : this.floored(this.totalAllocatedPercent - 1);
      this.supportRepartition.controls[0].setValue({
        ...this.supportRepartition.controls[0].value,
        initalRepartition: allocationLeft,
        shareCount: this.supportRepartition.controls[0].value.partPrice
          ? Math.round(
              (allocationLeft *
                this.supportRepartition.controls[0].value.totalInvestedAmount) /
                this.supportRepartition.controls[0].value.partPrice,
            )
          : '',
      });
      return;
    }

    // Allocation < 1 = set value left to the control
    if (this.totalAllocatedPercent < 1) {
      let newControl =
        this.supportRepartition.controls[
          this.supportRepartition.value.length - 1
        ];
      return newControl.setValue({
        ...newControl.value,
        initalRepartition: 1 - this.totalAllocatedPercent,
        shareCount: this.supportRepartition.controls[
          this.supportRepartition.value.length - 1
        ].value.partPrice
          ? Math.round(
              ((1 - this.totalAllocatedPercent / 100) *
                this.supportRepartition.controls[
                  this.supportRepartition.value.length - 1
                ].value.totalInvestedAmount) /
                this.supportRepartition.controls[
                  this.supportRepartition.value.length - 1
                ].value.partPrice,
            )
          : '',
      });
    }
  }

  getPerf(support: any): string {
    if (support?.details?.performances?.perfP1Y)
      return (support?.details?.performances?.perfP1Y * 100).toFixed(2) + ' %';
    else return '~';
  }
  getPerfColor(support: any): string {
    let color = 'neutral';
    if (support?.details?.performances?.perfP1Y) {
      if (support?.details?.performances?.perfP1Y > 0.05) color = 'success';
      else if (support?.details?.performances?.perfP1Y < -0.05)
        color = 'danger';
      else color = 'warning';
    }
    return color;
  }
  getRisk(support: any): string {
    if (support?.details?.profilRisk?.value)
      return support?.details?.profilRisk?.value;
    else return '~';
  }
  getRiskColor(support: any): string {
    let color = 'neutral';
    if (support?.details?.profilRisk?.value) {
      if (support?.details?.profilRisk?.value >= 5) color = 'danger';
      else if (support?.details?.profilRisk?.value >= 3) color = 'warning';
      else color = 'success';
    }
    return color;
  }

  openSupportsForm() {
    this.supportsForm.open();
  }

  onSubmit() {
    this.derrors = true;

    // stop here if form is invalid
    if (this.form.invalid || this.totalAllocatedPercent != 1) {
      return;
    }

    this.doneSubject.next();
    if (this.callback) {
      // this.callback(this.extract());
    }
  }

  floored(value) {
    return Math.round(value * 100) / 100;
  }

  get supportRepartition() {
    return this.form.get('supportRepartition') as UntypedFormGroup;
  }

  get totalAllocatedPercent() {
    return this.floored(
      _(this.supportRepartition.value).map('initalRepartition').sum(),
    );
  }
  get allocationPanel() {
    if (
      !this.supportRepartition ||
      !this.supportRepartition.value ||
      this.supportRepartition.value.length == 0
    )
      return {
        display: 'info',
        icon: 'info',
        text: 'Renseignez vos investissements',
      };
    else if (this.totalAllocatedPercent > 1)
      return {
        display: 'danger',
        icon: 'error',
        text: `${Math.round(
          this.totalAllocatedPercent * 100,
        )}% au total - Vous ne pouvez pas repartir plus de 100% de l'investissement`,
      };
    else if (this.totalAllocatedPercent < 1)
      return {
        display: 'warning',
        icon: 'warning',
        text: `Il reste ${Math.round(
          this.form.get('supportRepartition').value[0].totalInvestedAmount *
            (1 - this.totalAllocatedPercent),
        )}€ de votre investissement à répartir, soit ${Math.round(
          (1 - this.totalAllocatedPercent) * 100,
        )}%`,
      };
    else if (
      _.filter(this.supportRepartition.value, scpi => !scpi.initalRepartition)
        .length
    )
      return {
        display: 'danger',
        icon: 'error',
        text: 'Vous ne pouvez pas repartir 0% dans un support',
      };
    else if (this.totalAllocatedPercent == 1)
      return {
        display: 'success',
        icon: 'check',
        text: 'Félicitations, vos investissements sont répartis à 100%',
      };
  }

  onMoreInfoClick(support) {
    window.open(`#/dashboard/assets/supports/${support.id}`, '_blank');
  }
}
